import { render, staticRenderFns } from "./PdfTemplate.vue?vue&type=template&id=60606859&scoped=true"
import script from "./PdfTemplate.vue?vue&type=script&lang=ts"
export * from "./PdfTemplate.vue?vue&type=script&lang=ts"
import style0 from "./PdfTemplate.vue?vue&type=style&index=0&id=60606859&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60606859",
  null
  
)

export default component.exports